<form [formGroup]="updateUserForm" class="contact-form" (ngSubmit)="onSubmit()">
    @if(!isSubmitting && submitSuccess === false) {
    <div class="alert alert-danger" role="alert">
        Something went wrong while updating the user. Please try again.
    </div>
    }
    <ms-input-label [isRequired]="isFieldRequired(updateUserForm, 'firstName')" [labelText]="'First Name'" />
    <input type="text" id="firstName" [required]="isFieldRequired(updateUserForm, 'firstName')" maxlength="50"
        formControlName="firstName" class="form-control"
        [class.is-invalid]="updateUserForm.get('firstName')?.invalid && updateUserForm.get('firstName')?.touched"
        [class.is-valid]="updateUserForm.get('firstName')?.valid && updateUserForm.get('firstName')?.touched && updateUserForm.get('firstName')?.value !== ''" />
    @if(updateUserForm.get('firstName')?.invalid && updateUserForm.get('firstName')?.touched) {
    <div class="error-messages">
        @if(updateUserForm.get('firstName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.FirstNameRequired}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(updateUserForm, 'lastName')" [labelText]="'Last Name'" class="mt-3" />
    <input type="text" id="lastName" [required]="isFieldRequired(updateUserForm, 'lastName')" maxlength="50" formControlName="lastName"
        class="form-control"
        [class.is-invalid]="updateUserForm.get('lastName')?.invalid && updateUserForm.get('lastName')?.touched"
        [class.is-valid]="updateUserForm.get('lastName')?.valid && updateUserForm.get('lastName')?.touched && updateUserForm.get('lastName')?.value !== ''" />
    @if(updateUserForm.get('lastName')?.invalid && updateUserForm.get('lastName')?.touched) {
    <div class="error-messages">
        @if(updateUserForm.get('lastName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1">{{FormValidatorMessages.LastNameRequired}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(updateUserForm, 'telephone')" [labelText]="'Phone Number'" class="mt-3" />
    <ms-phone-input id="phone-number" formControlName="telephone" />


    <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || !isAnyFieldChanged()">
            @if(isSubmitting) {
            <div class="spinner-border text-light spinner-border-sm me-2" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
                Updating...
            } @else {
                Update User
            }
        </button>
    </div>
</form>
